module.exports = __webpack_public_path__ + "static/education-1b8f2543ebb36152938d18d4dc581480.png";